module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_ac_up-aca3583f9b5eb38687a59dba38704431.png";